import { image } from "./image";

const avtarList = [
    {
        id: 1,
        url: image.AVATAR1
    },
    {
        id: 2,
        url: image.AVATAR2
    },
    {
        id: 3,
        url: image.AVATAR3
    },
    {
        id: 4,
        url: image.AVATAR4
    },
    {
        id: 5,
        url: image.AVATAR5
    },
    {
        id: 6,
        url: image.AVATAR6
    },
    {
        id: 7,
        url: image.AVATAR7
    }
]
const getAvatarUrl = (avatarId: number) => {
    return avtarList.find(avatar => avatar.id === avatarId)?.url;
};
export default getAvatarUrl;